// List_robots.js  
const robots = [         
  { name: 'X015_001', greenhouse: '', location: 'つくばオフィス', kinds: 'cu', lift: 'low', demo: false },        
  { name: 'X015_002', greenhouse: '', location: '群馬お客様', kinds: 'cu', lift: 'low', demo: false },      
  { name: 'X015_003', greenhouse: '', location: '埼玉お客様', kinds: 'cu', lift: 'high', demo: false },      
  { name: 'X015_004', greenhouse: '', location: '埼玉お客様', kinds: 'cu', lift: 'high', demo: false },      
  { name: 'X015_005', greenhouse: '', location: 'つくばオフィス', kinds: 'gp', lift: 'high', demo: false },      
  { name: 'X015_006', greenhouse: 'PHHK-1', location: '東串良', kinds: 'gp', lift: 'high', demo: true }, 
  { name: 'X015_009', greenhouse: '', location: '宮崎県', kinds: 'gp', lift: 'low', demo: false },   
  { name: 'X015_010', greenhouse: '', location: '宮崎県', kinds: 'gp', lift: 'low', demo: false },   
  { name: 'X015_011', greenhouse: '', location: '宮崎県', kinds: 'gp', lift: 'low', demo: false },   
  { name: 'X015_012', greenhouse: '', location: '宮崎県', kinds: 'gp', lift: 'low', demo: false },   
  { name: 'X015_013', greenhouse: '', location: '宮崎市', kinds: 'cu', lift: 'low', demo: false },
  { name: 'X015_014', greenhouse: '', location: 'Microsoft AI Co-Innovation Lab Kobe', kinds: 'gp', lift: 'high', demo: false },   
  { name: 'X015_015', greenhouse: 'THSN', location: '新富トレセン', kinds: 'gp', lift: 'high', demo: true },      
  { name: 'X015_999', greenhouse: '', location: '清水開発用', kinds: 'gp', lift: 'high', demo: false  }  
];   
  
export default robots;  
